export default __webpack_public_path__ + "static/media/endNode.17389e7a.PNG";